import React from 'react'
import { useTranslation } from 'i18n'
import { StepWizardChildProps } from 'react-step-wizard'
import { useAuth } from '../../hooks/useAuth'
import styles from './style.module.scss'
import XButton from 'v2/components/XButton'
import { BUTTON_SIZE, BUTTON_STYLE_TYPE } from 'v2/styles/constants'

interface Props {
    onClick: () => void
}

const XBack: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation(window.LANG_NS)
    return (
        <div className={styles.back__container}>
            <XButton
                styleType={BUTTON_STYLE_TYPE.ICON}
                size={BUTTON_SIZE.SMALL}
                leftIcon={'arrow_back'}
                onClick={props.onClick}
                ga4_key={t('back', { lang: 'en' })}
            >
                {t('back')}
            </XButton>
            <div className={styles.back__separator} />
        </div>
    )
}

export default XBack
